// extracted by mini-css-extract-plugin
export default {"whoImg":"WhoScreen_whoImg__KuzOz","whoText":"WhoScreen_whoText__ell2v"};